import { useState, useEffect } from 'react'
import { useQuery } from '@apollo/client'

import gql from 'graphql-tag'
import { DateTime } from 'luxon'
import cardEventFragment from '@components/card-event/card-event.fragment'

export const QUERY = gql`
query AllEvents($skip: Int, $limit: Int, $where: EventFilter) {
    eventCollection(
      limit: $limit,
      skip: $skip,
      order: startDate_ASC,
      where: $where
    ) {
      total
      items {
        ${cardEventFragment}
    }
  }
}
`

const usePagination = (isMobile, limit, programPageId) => {
  const [skip, setSkip] = useState(0)
  const defaultQuery = { program: { sys: { id: programPageId } } }
  const today = DateTime.local().startOf('day').toISO()
  const where = { AND: [defaultQuery, { startDate_gte: today }] }

  const {
    data, loading, fetchMore,
  } = useQuery(QUERY, {
    variables: {
      limit,
      skip,
      where,
    },
    notifyOnNetworkStatusChange: true,
  })

  const paginateDesktop = (newOffset) => {
    setSkip(newOffset)
  }

  const paginateMobile = () => {
    fetchMore({
      variables: {
        skip: data.eventCollection.items.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        return ({
          eventCollection: {
            items: [...prev.eventCollection.items, ...fetchMoreResult.eventCollection.items],
            total: fetchMoreResult.eventCollection.total,
            __typename: fetchMoreResult.eventCollection.__typename,
          },
        })
      },
    })
  }

  useEffect(() => {
    setSkip(0)
  }, [isMobile])

  const handlePagination = (newOffset) => {
    if (isMobile) {
      paginateMobile()
    } else {
      paginateDesktop(newOffset)
    }
  }

  return {
    data,
    loading,
    handlePagination,
    skip,
  }
}

export default usePagination
